<template>
  <div class="fullscrean">
    <div>
      <img src="../assets/logo-lecard.png" alt="Logo Lecard" style="width: 120px">
      <div class="mt-4">
        <h5 class="mb-1 font-weight-bold">Sistema pausado por falta de pagamento</h5>
        <p class="mb-4" style="max-width: 500px">
          Faça o pagamento para liberar o seu acesso
        </p>
        <div>
          <router-link class="btn btn-primary px-4" to="/portal">Pagar agora</router-link>
        </div>
        <div class="mt-4">
          <a href="javascript:" class="btn text-primary" @click="confirmLogout()">Sair do sistema</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopBar from "@/components/commons/TopBar";
  export default {
    name: 'Upgrade',
    components: {TopBar},

    methods: {
      confirmLogout() {
        this.$swal({
          text: "Deseja sair do sistema?",
          buttons: ["Cancelar", "Sim"],
          dangerMode: true
        }).then((result) => {
          if (result) {
            this.logout(true);
          }
        });
      },
    },

    mounted() {
      if (this.$store.state.dataUser.status_empresa === '2') {
        window.location.href = this.$helpers.getLink();
      }
    }
  }
</script>

<style scoped>
.fullscrean {
  display: flex;
  height: 95vh;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  width: 100%;
  text-align: center;
}

@media (max-height: 630px) {
  .fullscrean {
    height: auto;
    margin-top: 132px;
  }
}
</style>
